<!-- =========================================================================================
  File Name: DeviceDetailSidebar.vue
  Description: View Detail - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/DeviceTranslate.json"></i18n>

<template>
	<el-dialog append-to-body class="custom-dialog" :visible.sync="isSidebarActiveLocal">
		<div slot="title" class="flex justify-between items-center w-full">
			<span class="el-dialog__title break-normal">{{ $t("DetailDevice") }}</span>
			<DeviceContextMenu
				displayMode="detail"
				:device="data"
				@onClickEdit="deviceId => $emit('onClickEdit', deviceId)"
				@onClickDelete="deviceId => $emit('onClickDelete', deviceId)"
				@onClickCreateTodo="deviceId => $emit('onClickCreateTodo', deviceId)"
				@onClickCreateRequest="deviceId => $emit('onClickCreateRequest', deviceId)"
				@onClickManageChecklist="device => $emit('onClickManageChecklist', device)"
				@onClickManageAccessories="deviceId => $emit('onClickManageAccessories', deviceId)"
				@onClickCloneKpis="deviceId => $emit('onClickCloneKpis', deviceId)"
				@onClickCreateKpis="deviceId => $emit('onClickCreateKpis', deviceId)"
			/>
		</div>

		<PerfectScrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings" v-if="isSidebarActiveLocal">
			<el-collapse v-model="activeGeneral" class="cbs-collapse mt-0">
				<el-collapse-item name="GeneralInfo">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("GeneralInfo") }}</h6>
						</div>
					</template>
					<div class="px-6 pt-6">
						<vs-row class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Name") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ dataName }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Code") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ dataCode }}</vs-col>
						</vs-row>

						<vs-row v-if="categoryName" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Category") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ categoryName }}</vs-col>
						</vs-row>

						<vs-row v-if="managerName" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Manager") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ managerName }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Tag") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ tags }}</vs-col>
						</vs-row>
					</div>
				</el-collapse-item>
			</el-collapse>

			<!-- Extra info -->
			<el-collapse class="cbs-collapse mt-0">
				<el-collapse-item name="ExtraInfo">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("ExtraInfo") }}</h6>
						</div>
					</template>
					<div class="p-6 pb-0">
						<vs-row v-if="dataSerial" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Serial") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ dataSerial }}</vs-col>
						</vs-row>
						<vs-row v-if="data.total_hrs" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("TotalHrs") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ data.total_hrs }}</vs-col>
						</vs-row>
						<vs-row v-if="data.current_hrs" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("CurrentHrs") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ data.current_hrs }}</vs-col>
						</vs-row>
						<vs-row v-if="data.maintain_hrs" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("MaintainHour") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ $helper.numFormat(data.maintain_hrs) }}</vs-col>
						</vs-row>
						<vs-row v-if="inventoryName" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Inventory") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ inventoryName }}</vs-col>
						</vs-row>
						<vs-row v-if="dataPrice" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Price") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ dataPrice | currency }}</vs-col>
						</vs-row>
						<vs-row v-if="manufactureYear" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("ManufactureYear") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ manufactureYear }}</vs-col>
						</vs-row>
						<vs-row v-if="warranty" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Warranty") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ warranty }}</vs-col>
						</vs-row>
						<vs-row v-if="operationDate" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("OperationDate") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ operationDate | dateTime(userDateFormat) }}</vs-col>
						</vs-row>
						<vs-row v-if="maintenanceTimes" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("MaintenanceTimes") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base lowercase">{{ maintenanceTimes }} {{ $t(`${maintenanceTimes > 1 ? "Times" : "Time"}`) }}</vs-col>
						</vs-row>
						<vs-row v-if="totalMaintenanceCost" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("TotalMaintenanceCost") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">{{ totalMaintenanceCost | currency }}</vs-col>
						</vs-row>
						<vs-row v-if="accessoryCurrentValue" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("MaintenanceCounter") }}:</label>
							</vs-col>
							<vs-col vs-w="8" vs-xs="6" class="text-black text-base">
								<div class="flex">
									{{ accessoryCurrentValue }}&nbsp;
									<div class="flex" v-if="isConfigAccessory">
										(<span class="flex items-center mr-3" v-if="isConfigAccessory">
											<i class="nucleo nucleo-t-warning-2 text-solid-orange-1 mr-1" :title="$t('AccessoryLimitWarningLevel')" />{{ accessoryWarningLimit }}
										</span>
										<span class="flex items-center">
											<i class="nucleo nucleo-time-warning text-solid-red mr-1" :title="$t('AccessoryLimitAlertLevel')" />{{ accessoryAlertLimit }} </span
										>)
									</div>
								</div>
							</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Status") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="font-bold" :style="{ color: statusColor }">{{ statusName }}</vs-col>
						</vs-row>
						<!-- Show Attachments Images -->
						<vs-row v-if="images && images.length > 0" class="mb-2">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Image") }}:</label>
							</vs-col>
							<vs-col>
								<cbs-upload-ref v-if="images && images.length > 0" :isEditable="false" :value="images" :key="dataId" />
							</vs-col>
						</vs-row>
						<!-- End Show Attachments Images -->
						<vs-row class="mb-2" v-if="employeeName">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Employee") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black text-base">{{ employeeName }}</vs-col>
						</vs-row>
						<vs-row class="mb-2" v-if="relations && relations.length">
							<vs-col vs-w="4" vs-xs="6">
								<label class="text-base" for>{{ $t("Relation") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black text-base">
								<DisplayRelations class="flex flex-col" :relations="relations" />
							</vs-col>
						</vs-row>
					</div>
				</el-collapse-item>
			</el-collapse>

			<!-- statistical -->
			<el-collapse :class="['cbs-collapse mt-0', statistics && statistics.length > 0 ? 'visible' : 'hidden']">
				<el-collapse-item name="Statistical">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("Actions.Statistical") }}</h6>
						</div>
					</template>
					<div class="px-6 pt-3">
						<div v-for="statistic in statistics" :key="`${statistic.id}${statistic.name}`">
							<span class="text-base">
								{{ statistic.name }} <span class="font-bold">({{ statistic.display }})</span>
							</span>
						</div>
					</div>
				</el-collapse-item>
			</el-collapse>

			<!-- Report -->
			<el-collapse @change="toggleReports" id="device-detail-report" class="cbs-collapse mt-0 vs-con-loading__container">
				<el-collapse-item name="Statistical">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("Report") }}</h6>
						</div>
					</template>
					<div class="px-6 pt-3">
						<div class="flex w-full justify-between">
							<div class="flex items-center">
								<vx-input-group class="w-1/3">
									<template slot="append">
										<div class="append-text text-black">
											<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker"></i>
										</div>
									</template>
									<cbs-date-picker
										clearable
										class="w-full"
										type="datetime"
										name="start-date"
										prefix-icon="''"
										ref="dateTimePickerRef"
										format="DD-MM-yyyy HH:mm"
										value-format="yyyy-MM-dd HH:mm:ss"
										:data-vv-as="$t('FromDate')"
										:placeholder="`${$t('FromDate')}`"
										v-model="from_date_report"
									/>
								</vx-input-group>
								<span class="mx-1">đến</span>
								<vx-input-group class="w-1/3">
									<template slot="append">
										<div class="append-text text-black">
											<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker"></i>
										</div>
									</template>
									<cbs-date-picker
										clearable
										class="w-full"
										type="datetime"
										name="start-date"
										prefix-icon="''"
										ref="dateTimePickerRef"
										format="DD-MM-yyyy HH:mm"
										value-format="yyyy-MM-dd HH:mm:ss"
										:data-vv-as="$t('ToDate')"
										:placeholder="`${$t('ToDate')}`"
										v-model="to_date_report"
									/>
								</vx-input-group>
								<vs-button class="ml-2" @click="getDeviceReports()">{{ $t("View") }}</vs-button>
							</div>
							<cbs-download-button class="" btnText="" @click.stop="handleDownloadDeviceReport" />
						</div>
						<vs-divider />
						<iframe class="w-full h-56 debt-report-container border-none" allowfullscreen="true" :src="deviceReport"></iframe>
					</div>
				</el-collapse-item>
			</el-collapse>

			<!-- KPI Tab -->
			<el-collapse :class="['cbs-collapse mt-0 animate-bottom', $store.state.deviceManagement.totalKpiDetails > 0 ? 'visible' : 'hidden']">
				<el-collapse-item name="RemindWork">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("RemindWorkList") }}</h6>
						</div>
					</template>
					<div class="px-6 pt-3">
						<ListDeviceKpi :device="data" @editDataKpi="data => $emit('onClickCreateKpis', data)" @onClickResetKpiHour="data => $emit('onClickResetKpiHour', data)" />
					</div>
				</el-collapse-item>
			</el-collapse>

			<!-- End KPI Tab-->

			<!-- Accessory Tab -->
			<el-collapse :class="['cbs-collapse mt-0 animate-bottom', $store.state.deviceManagement.totalAccessories > 0 ? 'visible' : 'hidden']">
				<el-collapse-item name="Accessory">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("AccessoryList") }}</h6>
						</div>
					</template>
					<div class="px-6 pt-3">
						<ListDeviceAccessories
							ref="device-accessories"
							@onLoadMoreAccessories="getDeviceAccessories"
							@editDataAccessory="data => $emit('editDataAccessory', data)"
							@onClickCreateTodo="relation => $emit('onClickCreateTodo', relation)"
							@onClickCreateRequest="relation => $emit('onClickCreateRequest', relation)"
							:type="$constant.ACCESSORY_TYPE.ACCESSORY"
							:device="data"
							:totalItems="$store.state.deviceManagement.totalAccessories"
							:accessories="$store.getters['deviceManagement/getParsedAccessories']"
							:limit="5"
						/>
					</div>
				</el-collapse-item>
			</el-collapse>
			<!-- End Accessory Tab -->

			<!-- Material Tab -->
			<el-collapse :class="['cbs-collapse mt-0 animate-bottom', $store.state.deviceManagement.totalMaterial > 0 ? 'visible' : 'hidden']">
				<el-collapse-item name="Material">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("MaterialList") }}</h6>
						</div>
					</template>
					<div class="px-6 pt-3">
						<ListDeviceAccessories
							@onLoadMoreAccessories="getDeviceAccessories"
							ref="device-material"
							@editDataAccessory="data => $emit('editDataAccessory', data)"
							@onClickCreateTodo="relation => $emit('onClickCreateTodo', relation)"
							@onClickCreateRequest="relation => $emit('onClickCreateRequest', relation)"
							:type="$constant.ACCESSORY_TYPE.MATERIAL"
							:device="data"
							:totalItems="$store.state.deviceManagement.totalMaterial"
							:accessories="$store.getters['deviceManagement/getParsedMaterial']"
							:limit="5"
						/>
					</div>
				</el-collapse-item>
			</el-collapse>
			<!-- End Material Tab -->

			<!-- Collapse Current Task -->
			<el-collapse :class="['cbs-collapse mt-0 animate-bottom']" v-if="$store.state.deviceManagement.totalLogsCurrentTodo > 0">
				<el-collapse-item name="GeneralInfo">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("CurrentTask") }}</h6>
						</div>
					</template>
					<div class="px-6">
						<LogsTodoByRelations
							ref="logs-current-todo"
							:statuses="[0, 1, 4, 6]"
							:logsType="$constant.LOGS_DEVICE_TODO_TYPE.CURRENT"
							:relations="[{ id: dataId, type: 'Device' }]"
							:totalTodoList="$store.state.deviceManagement.totalLogsCurrentTodo"
							:todos="$store.state.deviceManagement.logsCurrentTodo"
							@onLoadMoreLogsTodo="getLogsTodoByDevice"
						/>
					</div>
				</el-collapse-item>
			</el-collapse>
			<!-- End Current Task -->

			<!-- Collapse Histories Task -->
			<el-collapse v-if="$store.state.deviceManagement.totalLogsDoneTodo > 0" class="cbs-collapse mt-0 animate-bottom">
				<el-collapse-item name="GeneralInfo">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("LogsTask") }}</h6>
						</div>
					</template>
					<div class="px-6">
						<LogsTodoByRelations
							ref="logs-done-todo"
							:limit="5"
							:statuses="[5]"
							:logsType="$constant.LOGS_DEVICE_TODO_TYPE.DONE"
							:relations="[{ id: dataId, type: 'Device' }]"
							:totalTodoList="$store.state.deviceManagement.totalLogsDoneTodo"
							:todos="$store.state.deviceManagement.logsDoneTodo"
							@onLoadMoreLogsTodo="getLogsTodoByDevice"
						/>
					</div>
				</el-collapse-item>
			</el-collapse>
			<!-- End Histories Task -->

			<!-- Collapse Histories Requests -->
			<el-collapse v-if="$store.state.deviceManagement.totalRequestsByDevice > 0" class="cbs-collapse mt-0 animate-bottom">
				<el-collapse-item name="GeneralInfo">
					<template slot="title">
						<div>
							<h6 class="uppercase font-bold ml-6">{{ $t("LogsRequest") }}</h6>
						</div>
					</template>
					<div class="px-6">
						<LogsRequestByRelations
							ref="logs-requests"
							:totalRequests="$store.state.deviceManagement.totalRequestsByDevice"
							:relations="[{ id: dataId, type: 'Device' }]"
							:requests="$store.state.deviceManagement.requestsByDevice"
							@onLoadMoreLogsRequest="getLogsRequestByDevice"
						/>
					</div>
				</el-collapse-item>
			</el-collapse>
			<!-- End Histories Requests -->

			<vs-table v-if="!!tasklist.length" class="device-checklist" :data="tasklist">
				<template slot="header">
					<div class="w-full">
						<h3 class="px-6 py-5 bg-gray-6 uppercase text-black text-base font-bold text-base">{{ $t("TaskList") }}</h3>
					</div>
				</template>

				<template slot-scope="{ data }">
					<vs-tr class="px-0" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<div class="flex justify-between items-center">
								<div class="device-checklist__content">
									<template v-if="tr.isIncident">
										<span class="text-danger font-bold">{{ $t("Incident") }}</span>
										<p v-if="tr.description" class="text-sm">
											<span class="font-bold">{{ $t("Note") }}:</span>
											{{ tr.description }}
										</p>
									</template>

									<template v-else>
										<p>{{ tr.name }}</p>
										<p class="text-gray-3 text-sm">{{ $t("UpdatedAt") }}: {{ tr.updatedTime | dateTime(userDateTimeFormat) }}</p>
									</template>
								</div>

								<div class="device-checklist__status-actions flex flex-col items-center">
									<p v-if="!tr.isIncident" :class="[{ 'text-solid-red': [1, 2].includes(tr.status), 'text-solid-green-2': [0, 4].includes(tr.status) }, 'font-bold text-right']">
										{{ $t(`TaskStatus.${$options.filters.taskStatus(tr.status)}`) }}
									</p>
									<span v-if="(tr.status && tr.status !== 0) || tr.isIncident" class="text-solid-primary cursor-pointer underline hover:font-bold" @click.stop="viewDetail(tr)">
										{{ $t("Actions.ViewDetail") }}
									</span>
								</div>
							</div>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</PerfectScrollbar>

		<vs-popup :title="$t('DetailIncident')" :active.sync="isShowModalDetail">
			<div class="modal-content">
				<div>
					<label class="text-base" for>{{ [0, 4].includes(modalDetailData.status) ? $t("Photo") : $t("IncidentPhoto") }}:</label>
					<img v-if="modalDetailData.image" :src="modalDetailData.image.path" alt class="responsive" />
				</div>
				<div class="mt-2" v-if="modalDetailData.status !== 4">
					<label class="text-base" for>Ghi chú:</label>
					<vs-textarea v-if="modalDetailData.isIncident" v-model="modalDetailData.description" readonly />
					<vs-textarea v-else v-model="modalDetailData.commentReadable" readonly />
				</div>
			</div>
		</vs-popup>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import { getUserPermissions, devicePermissions } from "@/mixins/mixins.js";

import DeviceContextMenu from "./DeviceContextMenu";
import DisplayRelations from "@/components/display-relations/DisplayRelations";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import LogsTodoByRelations from "@/components/logs-todo-by-relations/LogsTodoByRelations";
import LogsRequestByRelations from "@/components/logs-request-by-relations/LogsRequestByRelations";
import ListDeviceAccessories from "@/components/list-device-accessories/ListDeviceAccessories";

import ListDeviceKpi from "@/components/list-device-kpi/ListDeviceKpi";
import deviceGql from "@/http/requests/cbs/device_gql";

import moment from "moment";
export default {
	mixins: [getUserPermissions(devicePermissions)],
	components: {
		DisplayRelations,
		DeviceContextMenu,
		CbsUploadRef,
		LogsTodoByRelations,
		LogsRequestByRelations,
		ListDeviceAccessories,
		ListDeviceKpi
	},
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	watch: {
		isSidebarActive(val) {
			if (!val) {
				this.$store.dispatch("deviceManagement/resetDataLogsTodo");
				this.$store.dispatch("deviceManagement/resetDataAccessories");
				this.$store.dispatch("deviceManagement/resetDataLogsRequest");
				this.$store.dispatch("deviceManagement/resetDataKpiDetails");
				return;
			} else {
				this.setInitData();
				this.getLogsCurrentTodo();
				this.getLogsDoneTodo();
				this.getAccessories();
				this.getMaterials();
				this.getDeviceKpiList();
				this.getLogsRequestByDevice({ limit: 5, page: 1, relations: [{ id: this.dataId, type: "Device" }], orderBy: { column: "created_at", direction: "desc" } });
			}
		},
		data() {
			this.setInitData();
		}
	},
	data() {
		return {
			dataId: null,
			dataName: "",
			dataCode: "",
			dataSerial: "",
			statusName: "",
			statusColor: "",
			inventoryName: "",
			managerName: "",
			categoryName: "",
			employeeName: "",
			manufactureYear: null,
			warranty: null,
			operationDate: null,
			maintenanceTimes: null,
			totalMaintenanceCost: null,
			images: null,
			dataPrice: null,
			isConfigAccessory: false,
			accessoryCurrentValue: 0,
			accessoryWarningLimit: null,
			accessoryAlertLimit: null,
			relations: [],

			tasklist: [],
			incident: null,
			isShowModalDetail: false,
			modalDetailData: {},

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			activeGeneral: ["GeneralInfo"],
			statistics: [],
			deviceReport: "",
			from_date_report: "",
			to_date_report: ""
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		listDeviceStatus() {
			return _.get(this.$store, "state.deviceManagement.devicesStatus") || [];
		},
		tags() {
			const _t = this.data.tags.map(item => item.name);
			return _t.toString();
		}
	},
	methods: {
		viewDetail(data) {
			this.modalDetailData = {
				...data,
				commentReadable: _.get(data, "comment.title") || ""
			};
			this.isShowModalDetail = true;
		},
		setInitData() {
			let {
				inventoryName,
				managerName,
				categoryName,
				employeeName,
				id,
				images,
				name,
				code,
				price,
				used_at,
				checked_times,
				repaired_total_cost,
				properties,
				statusName,
				statusColor,
				tasklist,
				relations,
				incident,
				is_configured,
				current,
				warning_threshold,
				alert_threshold,
				statistic_todolists,
				statistic_request
			} = this.data;

			const parsedProperties = properties ? JSON.parse(properties) : {};
			const mfg = _.get(parsedProperties, "mfg");
			const warranty = _.get(parsedProperties, "wd");
			const serial = _.get(parsedProperties, "serial");

			this.dataId = id;
			this.inventoryName = inventoryName;
			this.managerName = managerName;
			this.categoryName = categoryName;
			this.employeeName = employeeName;
			this.images = images;
			this.dataCode = code;
			this.dataSerial = serial;
			this.dataName = name;
			this.dataPrice = price;
			this.operationDate = used_at || null;
			this.maintenanceTimes = checked_times;
			this.totalMaintenanceCost = repaired_total_cost;
			this.manufactureYear = mfg || "";
			this.warranty = warranty;
			this.statusName = statusName;
			this.statusColor = statusColor;
			this.tasklist = tasklist;
			this.incident = incident;
			this.relations = relations || [];
			this.accessoryCurrentValue = current || 0;
			this.isConfigAccessory = is_configured || false;
			this.accessoryAlertLimit = alert_threshold || null;
			this.accessoryWarningLimit = warning_threshold || null;
			this.statistics = [...statistic_todolists, ...statistic_request];
		},
		onUpdateLogsRequestByRelations(response) {
			this.$store.commit("deviceManagement/SET_LOGS_REQUEST_BY_DEVICE", [response, ...this.$store.state.deviceManagement.requestsByDevice]);
		},

		toggleReports(ev) {
			if (ev.length > 0) {
				this.getDeviceReports();
			}
		},
		async getDeviceReports(type = "html") {
			this.$vs.loading({
				container: "#device-detail-report",
				scale: 0.6
			});
			try {
				const respone = await deviceGql.exportReportDevice({
					device_id: this.dataId,
					type: type,
					to_start_date: moment(this.to_date_report).toISOString(),
					from_start_date: moment(this.from_date_report).toISOString()
				});
				this.deviceReport = respone.reportDevice;
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close("#device-detail-report > .con-vs-loading");
			}
		},
		handleDownloadDeviceReport() {
			this.getDeviceReports("excel");
		},
		triggerClickDatetimePicker() {
			this.$refs.dateTimePickerRef.$children[0].pickerVisible = true;
		},
		getLogsCurrentTodo() {
			this.getLogsTodoByDevice({ limit: -1, page: 1, statuses: [0, 1, 4, 6], relations: [{ id: this.dataId, type: "Device" }], logsType: this.$constant.LOGS_DEVICE_TODO_TYPE.CURRENT });
		},
		getLogsDoneTodo() {
			this.getLogsTodoByDevice({ limit: 5, page: 1, statuses: [5], relations: [{ id: this.dataId, type: "Device" }], logsType: this.$constant.LOGS_DEVICE_TODO_TYPE.DONE });
		},
		async getLogsTodoByDevice(data) {
			try {
				const payload = {
					limit: data.limit,
					page: data.page,
					statuses: data.statuses,
					relations: data.relations,
					type: 0,
					orderBy: { column: "created_at", direction: "desc" },
					logsType: data.logsType
				};
				await this.$store.dispatch("deviceManagement/getLogsDeviceTodo", payload);
				if (data.logsType === this.$constant.LOGS_DEVICE_TODO_TYPE.CURRENT) {
					if (this.$refs["logs-current-todo"]) this.$refs["logs-current-todo"].finishedLoadMore();
				} else {
					if (this.$refs["logs-done-todo"]) this.$refs["logs-done-todo"].finishedLoadMore();
				}
			} catch (error) {
				console.error(error);
			}
		},
		async handleCreateNewTodo() {
			await this.$store.commit("deviceManagement/SET_LOGS_CURRENT_TODO", []);
			this.getLogsCurrentTodo();
		},
		getAccessories() {
			this.getDeviceAccessories({ device_id: this.dataId, limit: 5, page: 1, type_id: this.$constant.ACCESSORY_TYPE.ACCESSORY });
		},
		getMaterials() {
			this.getDeviceAccessories({ device_id: this.dataId, limit: 5, page: 1, type_id: this.$constant.ACCESSORY_TYPE.MATERIAL });
		},
		async getDeviceAccessories(data) {
			try {
				await this.$store.dispatch("deviceManagement/fetchAccessories", data);
				if (data.type_id === this.$constant.ACCESSORY_TYPE.ACCESSORY) {
					if (this.$refs["device-accessories"]) this.$refs["device-accessories"].finishedLoadMore();
				} else {
					if (this.$refs["device-material"]) this.$refs["device-material"].finishedLoadMore();
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getDeviceKpiList(isRefetch = false) {
			try {
				const queryOptions = {
					kpiable_id: this.data.id,
					kpiable_type: this.$constant.KPIV2.KPIABLE_TYPE.DEVICE
				};
				if (isRefetch) {
					queryOptions.fetchPolicy = "no-cache";
				}

				await this.$store.dispatch("deviceManagement/fetchKpiDetails", queryOptions);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		async getLogsRequestByDevice(data) {
			try {
				await this.$store.dispatch("deviceManagement/getLogsRequestByDevice", data);
				if (this.$refs["logs-requests"]) this.$refs["logs-requests"].finishedLoadMore();
			} catch (error) {
				console.error(error);
			}
		}
	}
};
</script>
